

const About = () => {
    return (
        <div className="bg-gray-100 min-h-screen py-24">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">About Us</h1>
            <p className="text-gray-800 text-lg">
            In collaboration with their computer class, the students built an impressive website to showcase their diverse range of projects. Each student contributed a unique project, which consisted of three key elements: a personally curated playlist of important videos, a captivating picture created using AI technology (Dall-e 2), and an AI-generated background for their 3D playlist room. The website provided a platform for the students to share their interests, creativity, and technological prowess, resulting in a fascinating display of their accomplishments. The combination of personalization and cutting-edge AI technology made the website a captivating representation of the students' talents and achievements.
            </p>
          </div>
        </div>
      );
}
export default About